module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-content"
  }, [_c('div', {
    staticClass: "app-content-body leiloes"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06e8aa0a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/historico-alteracoes/Main.vue
// module id = 1470
// module chunks = 17